import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const shutdownAlisaActiveKey = (shutdownId) => [
  'shutdownAlisaActiveHistory',
  shutdownId,
];

const shutdownAlisaActiveQuery = async ({ queryKey }) => {
  const [_, shutdownId] = queryKey;

  return await request.get(
    `/Alert/alisa_active/${shutdownId}`,
    {},
    `При определении активности автоответчика произошла ошибка`
  );
};

export const useShutdownAlisaActive = (shutdownId, options) =>
  useQuery(
    shutdownAlisaActiveKey(shutdownId),
    shutdownAlisaActiveQuery,
    options
  );
